module.exports = __webpack_public_path__ + "static/media/plugin-sort-desc.f0606467.svg";